import { Col, Row, Form, Input, Button, Card, Tabs } from "antd";
import { ImWhatsapp } from "react-icons/im";
import { ImageUrl } from "../../config/helper";
import { Container } from "postcss";
import { FaArrowRightLong } from "react-icons/fa6";
import FancyVideo from "react-videojs-fancybox";
import { useNavigate } from "react-router-dom";
const { Meta } = Card;
const onChange = (key) => {
  console.log(key);
};
const blackLuxuryimageList = [
  "model1.png",
  "model2.png",
  "model3.png",
 
];
const ultraLuxuryimageList = [
 "ultra1.png",
  "ultra2.png",
  "ultra3.png",
];
const suvimageList = [
  "suv1.png",
  "suv2.png",
  "suv3.png",
];
const sprintersimageList = [
 "sprinters1.png",
  "sprinters2.png",
  "sprinters3.png",
];
const items = [
  {
    key: "1",
    label: "Black Luxury",
    children: (
      <>
        <Row gutter={[16, 16]}>
          {blackLuxuryimageList.map((image, index) => (
            <Col key={index} xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
              <img
                src={ImageUrl(image)}
                alt={`vector ${index + 1}`}
                className=""
              />
            </Col>
          ))}
        </Row>
      </>
    ),
  },
  {
    key: "2",
    label: "Ultra Luxury",
    children: (
      <>
        <Row gutter={[16, 16]}>
          {ultraLuxuryimageList.map((image, index) => (
            <Col key={index} xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
              <img
                src={ImageUrl(image)}
                alt={`vector ${index + 1}`}
                className=""
              />
            </Col>
          ))}
        </Row>
      </>
    ),
  },
  {
    key: "3",
    label: "SUV Luxury",
    children: (
      <>
        <Row gutter={[16, 16]}>
          {suvimageList.map((image, index) => (
            <Col key={index} xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
              <img
                src={ImageUrl(image)}
                alt={`vector ${index + 1}`}
                className=""
              />
            </Col>
          ))}
        </Row>
      </>
    ),
  },
  {
    key: "4",
    label: "Sprinters Luxury",
    children: (
      <>
        <Row gutter={[16, 16]}>
          {sprintersimageList.map((image, index) => (
            <Col key={index} xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
              <img
                src={ImageUrl(image)}
                alt={`vector ${index + 1}`}
                className=""
              />
            </Col>
          ))}
        </Row>
      </>
    ),
  },
];

const HomeComponent12 = () => {
  const navigate = useNavigate();
  return (
    <>
      <section className="py-5 models-page">
        <Row justify={"center"}>
          <Col lg={16}>
            <Row justify="center" className="items-center">
              <Col xxl={24} md={24} sm={24} xs={24}>
                <h3 className="font-goldman text-white xldesktop:text-[40px] laptop:text-[36px] mobile:text-[26px] leading-[60px] text-center">
                  Our Gallery
                </h3>
                <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
              </Col>
            </Row>
            {/* <Row justify={"center"} className="pt-6">
              <Col lg={23} md={23} sm={23} xs={23}>
                <Row justify={"space-around"} gutter={[16, 16]}>
                  <Tabs
                    defaultActiveKey="1"
                    items={items}
                    onChange={onChange}
                  />
                </Row>
              </Col>
            </Row> */}

            <div className="text-center mt-3">
              <button
                className="web-btn py-3 xl:px-12 px-3 text-sm max-xl:text-xs my-4 max-lg:hidden"
                // onClick={() => navigate("/signIn")}
                onClick={() => navigate("/contact")}
              >
                Book Now!
              </button>
            </div>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default HomeComponent12;
